import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'archivefilter',
  pure: false
})
export class ArchiveFilterPipe implements PipeTransform {
  transform(items: any[]): any {
    if (items == null) {
      return items;
    }
    return items.filter(item => !item.archived);
  }
}
